import { render, staticRenderFns } from "./KickMixScreen.vue?vue&type=template&id=88311432&scoped=true"
import script from "./KickMixScreen.vue?vue&type=script&lang=js"
export * from "./KickMixScreen.vue?vue&type=script&lang=js"
import style0 from "./KickMixScreen.vue?vue&type=style&index=0&id=88311432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88311432",
  null
  
)

export default component.exports